<script setup>
import { computed, getCurrentInstance } from 'vue';
import HelpBox from '../../common/HelpBox';
import ThemesEditorNavLink from './ThemesEditorNavLink';
import ThemesEditorAlphaSortBtn from "./ThemesEditorAlphaSortBtn.vue";
import ThemesEditorNavSearch from "./ThemesEditorNavSearch.vue";

const { proxy } = getCurrentInstance();
const store = proxy.$store;

// --- Computed ---

const alphaMode = computed(() => store.state.alphaMode);
const activeEditorKey = computed(() => store.state.themes.activeEditorKey);
const items = computed(() => store.state.themes.items);
const sectionName = computed(() => store.state.themes.sectionName);
const navSearch = computed(() => store.state.themes.navSearch);
const sortAlpha = computed(() => store.state.themes.sortAlpha);

const helpBlockId = computed(() => 'themesEditorNavSection-' + sectionName.value);

const sectionData = computed(() => {
    return store.getters['themes/getSectionsSettings'](sectionName.value);
});

const contentTypes = computed(() => {
    return [...new Set(items.value.map(o => o.contentType))].sort();
});

const filteredItems = computed(() => {
    if (sectionName.value === 'content_types' && navSearch.value !== '') {
        const query = navSearch.value.toLowerCase();
        return items.value.filter(o => o.title.toLowerCase().includes(query));
    }
    return items.value;
});
</script>

<template>
    <div class="themes-editor-nav-section overflow-y-scroll h-100">
        <HelpBox v-if="sectionData.helpText && alphaMode" :id="helpBlockId">
            <div class="mb-1 fw-bold">{{ sectionData.title }}</div>
            <div v-html="sectionData.helpText"></div>
        </HelpBox>

        <div v-if="sectionName === 'content_types'" class="d-flex align-items-center mb-2 pt-1">
            <ThemesEditorNavSearch/>
            <ThemesEditorAlphaSortBtn/>
        </div>

        <template v-if="sectionName === 'content_types' && !sortAlpha && navSearch === ''">
            <template v-for="contentType in contentTypes">
                <h6 class="mt-5 w-100 ps-2 pb-2 border-bottom text-secondary-emphasis" :key="'header-' + contentType">
                    {{ contentType }}
                </h6>
                <ThemesEditorNavLink
                    v-for="item in items.filter(o => o.contentType === contentType)"
                    :key="item.id"
                    :active-editor-key="activeEditorKey"
                    :item="item"
                />
            </template>
        </template>

        <template v-else>
            <ThemesEditorNavLink
                v-for="item in filteredItems"
                :key="item.id"
                :active-editor-key="activeEditorKey"
                :item="item"
            />
        </template>

        <div class="my-5 py-5">&nbsp;</div>
    </div>
</template>